export default "__VITE_ASSET__COPvuHYo__"